<mat-sidenav-container class="sidenav-container">
	<mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
		[mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
		<mat-toolbar>
			<a routerLink="/">
				<img src="/assets/images/ApplioSpacesLogo.png" alt="Applio Spaces" class="logo" width="250"
					height="32" /><!--H 44.8 Orginal höjd-->
			</a>
		</mat-toolbar>
		<app-sidebar-menu></app-sidebar-menu>
		<div *ngIf="isHandset$ | async">
			<button (click)="onLogout()" mat-flat-button color="primary">Sign out</button>
		</div>
	</mat-sidenav>
	<mat-sidenav-content>
		<app-main-header [isHandset$]="isHandset$" [drawer]="drawer"></app-main-header>
		<main class="main-container">
			<router-outlet></router-outlet>
		</main>
	</mat-sidenav-content>
</mat-sidenav-container>